/* global axios */

const customToolsUrl = accountId =>
  `/api/v1/accounts/${accountId}/lilith/custom_tools`;

export const getLilithCustomTools = accountId =>
  axios.get(customToolsUrl(accountId));

export const getLilithEffectRecovery = (accountId, offset = 0) =>
  axios.get(`${customToolsUrl(accountId)}/effect_recovery`, { params: { offset } });

export const reconcileLilithEffect = (accountId, runId, callId, data) =>
  axios.post(
    `${customToolsUrl(accountId)}/effect_recovery/${encodeURIComponent(runId)}`,
    { reconciliation: { ...data, call_id: callId } }
  );

export const createLilithCustomTool = (accountId, data) =>
  axios.post(customToolsUrl(accountId), { custom_tool: data });

export const updateLilithCustomTool = (accountId, toolId, data) =>
  axios.put(`${customToolsUrl(accountId)}/${toolId}`, {
    custom_tool: data,
  });

export const deleteLilithCustomTool = (accountId, toolId) =>
  axios.delete(`${customToolsUrl(accountId)}/${toolId}`);

export const testLilithCustomTool = (accountId, data) =>
  axios.post(`${customToolsUrl(accountId)}/test`, {
    custom_tool: data,
  });
